import React from 'react';
import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import clsx from 'clsx';
import { StepStatusCaseType } from '@/interfaces';

interface Props {
	position?: string;
	status: StepStatusCaseType;
}

export const CircleStatus: React.FC<Props> = ({ position, status }) => {
	let currentIcon = Icons.briefcase;
	switch (status) {
		case 'default':
			currentIcon = Icons.briefcase;
			break;
		case 'incomplete':
			currentIcon = Icons.infoCircle;
			break;
		case 'completed':
		case 'approved':
			currentIcon = Icons.check;
			break;
		default:
			currentIcon = Icons.briefcase;
			break;
	}

	return (
		<div
			className={clsx(
				'rounded-full border-2 border-gray-10 py-[2px] px-1.5 mt-1 size-8 flex items-center justify-center bg-grey-100',
				{
					'!border-green-60 !bg-green-60': status === 'approved',
				}
			)}
		>
			{status === 'approved' && (
				<Icon
					src={currentIcon}
					className={clsx('!size-20 text-grey-60', {
						// '!text-[#FD9834]': status === 'incomplete',
						// '!text-purple-150': status === 'completed',
						'!text-white': status === 'approved',
					})}
				/>
			)}
			{status !== 'approved' && (
				<Typography type="semibold-14" className="text-gray-35">
					{position}
				</Typography>
			)}
		</div>
	);
};
